export default __webpack_public_path__ + "static/media/fullFridge_3.f1bcc634.jpeg";